import React from 'react';
import { Card, CardContent } from '../components/ui/Card';
import SafeIcon from '../common/SafeIcon';

export const PlaceholderPage = ({ title, description, icon }) => {
  return (
    <div className="h-[80vh] flex items-center justify-center">
      <Card className="max-w-md w-full text-center">
        <CardContent className="p-12">
          <div className="w-20 h-20 rounded-2xl bg-indigo-50 text-indigo-600 flex items-center justify-center mx-auto mb-6">
            <SafeIcon name={icon} className="text-4xl" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2">{title}</h2>
          <p className="text-slate-500 mb-8">{description}</p>
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-slate-100 text-slate-600 rounded-full text-sm font-medium">
            <SafeIcon name="Code" />
            Under utvikling
          </div>
        </CardContent>
      </Card>
    </div>
  );
};